import $ from 'jquery';
import jQuery from 'jquery';
import { createApp } from 'vue';
import ReferralMailComponent from './components/landingpage/ReferralMailComponent.vue';
import moment from 'moment';
import Toaster from '@meforma/vue-toaster';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

// ハンバーガーメニュー
class Ios15ModalHack {
  constructor() {
    this.init();
    this.load();
    this.resize();
  }
  init() {
    const styleTag = document.createElement('style');
    styleTag.innerText = '@media (max-width: 768px) {html.is-locked,html.is-locked body {height: calc(var(--window-inner-height) + ${window.scrollY}px - 1px);overflow: hidden;box-sizing: border-box;}}';
    document.getElementsByTagName('head')[0].insertAdjacentElement('beforeend', styleTag);
  }
  syncHeight() {
    document.documentElement.style.setProperty('--window-inner-height', `${window.innerHeight}px`);
  }
  load() {
    window.addEventListener('load', () => {
      this.syncHeight();
    });
  }
  resize() {
  // if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
  //   return;
  // } else {
  window.addEventListener('resize', () => {
    this.syncHeight();
  });
  // }
  }
}
const App = new Ios15ModalHack();

$(document).on('click', '.l-header__openbtn', function () {
  $(this).toggleClass('is-active');
  $(".l-header__navwrap").toggleClass('is-panelactive');
  $("html").toggleClass('is-locked');
});
$(document).on('click', '.l-header__nav a', function () {
  if ($(this).attr('href')) {
    $(".l-header__openbtn").removeClass('is-active');
    $(".l-header__navwrap").removeClass('is-panelactive');
    $("html").removeClass('is-locked');
  }
});

//画像レスポンシブ切り替え
(($) => {
  $(() => {
    const imageSwitch = () => {
      const switchImages = document.querySelectorAll(".js-image-switch");
      for (let i = 0; i < switchImages.length; i++) {
        let switchImage = switchImages[i];
        let src = switchImage.getAttribute('src');
        if (window.matchMedia('(max-width: 767px)').matches) {
          //スマホ処理
          let result = src.includes('-sp.');
          if (!result) {
            let spSrc = switchImage.getAttribute('src').replace(/\.([^.]*)$/, '-sp.$1');
            switchImage.setAttribute('src', spSrc);
          }
        } else if (window.matchMedia('(min-width:768px)').matches) {
          //PC処理
          let result = src.includes('-sp.');
          if (result) {
            let pcSrc = switchImage.getAttribute('src').replace('-sp.', '.');
            switchImage.setAttribute('src', pcSrc);
          }
        }
      }
    }
    imageSwitch();
    var resizeTimer;
    $(window).on('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        imageSwitch();
      }, 200);
    });
  });
})(jQuery);

$(function () {

  // アコーディオン
  $('.js-accordion-head').on('click', function() {
    $(this).toggleClass('is-open');
    $(this).next('.js-accordion-body').slideToggle();
  });

  const sliderSelector = '.js-category-slider';
  const breakpoint = 768;
  let swiperInstance = null;

  function initSwiper() {
    const sliderElem = document.querySelector(sliderSelector);
    
    // 1. ページ内に要素がない場合は処理をスキップ（エラー防止）
    if (!sliderElem) return;

    const windowWidth = window.innerWidth;

    // 2. SPサイズ（breakpoint未満）の判定
    if (windowWidth < breakpoint) {
      // すでに初期化済みの場合は二重で初期化しない
      if (swiperInstance !== null) return;

      // Swiperの初期化
      swiperInstance = new Swiper(sliderSelector, {
        loop: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    } else {
      // 3. PCサイズ（breakpoint以上）の場合
      if (swiperInstance !== null) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }
  }

  // ロード時の実行
  initSwiper();

  // 4. リサイズ時の実行
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      initSwiper();
    }, 200);
  });
});
// Vue.jsの初期化

const app = createApp({
    components: {
        'referral-mail-component': ReferralMailComponent
    },
    data() {
        return {
        }
    }
})
app.use(Toaster, {
    position: "top",
    duration: 2000,
});

app.use(moment);
app.mount('#form-referral');
